import { useState } from 'react';
import { showToast } from '@/components/base/Toast';
import { topicTags } from '@/mocks/home';

const SORTS = ['按热度', '按更新', '按收藏'];

export default function TagSection() {
  const [activeTags, setActiveTags] = useState<string[]>(['经典白衬衫', '暖光氛围']);
  const [sort, setSort] = useState(SORTS[0]);

  const toggleTag = (tag: string) => {
    setActiveTags((prev) =>
      prev.includes(tag) ? prev.filter((item) => item !== tag) : [...prev, tag],
    );
  };

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-[1200px]">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-4">
              <div className="mb-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-price-tag-3-line text-lg" />
                </span>
                <span className="text-xs font-medium uppercase tracking-[0.25em] text-secondary-600">
                  Topic Tags
                </span>
              </div>
              <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                按主题找资源
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                想先选定方向？点击标签组合你想看的主题，例如「经典白衬衫 + 暖光氛围」，
                快速缩小选题范围。
              </p>
              <div className="mt-6 flex items-center gap-2">
                <span className="text-xs text-foreground-500">排序预览</span>
                <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
                  {SORTS.map((item) => (
                    <button
                      key={item}
                      type="button"
                      onClick={() => setSort(item)}
                      className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors duration-200 ${
                        sort === item
                          ? 'bg-primary-500 text-background-50'
                          : 'text-foreground-600 hover:text-primary-700'
                      }`}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:col-span-8">
              <div className="flex flex-wrap gap-3">
                {topicTags.map((tag) => {
                  const active = activeTags.includes(tag);
                  return (
                    <button
                      key={tag}
                      type="button"
                      onClick={() => toggleTag(tag)}
                      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors duration-200 ${
                        active
                          ? 'border-accent-500 bg-accent-500 text-background-50'
                          : 'border-background-300 bg-background-100 text-foreground-700 hover:border-accent-300 hover:text-accent-700'
                      }`}
                    >
                      <i className={active ? 'ri-checkbox-circle-fill text-base' : 'ri-add-line text-base'} />
                      {tag}
                    </button>
                  );
                })}
              </div>

              <div className="mt-6 flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div className="text-sm text-foreground-700">
                  {activeTags.length > 0 ? (
                    <span>
                      已选主题：
                      <strong className="font-medium text-primary-700">
                        {activeTags.join(' · ')}
                      </strong>
                    </span>
                  ) : (
                    <span>尚未选择主题，可点击上方标签开始</span>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => showToast(`已按「${sort}」预览主题资源`)}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
                >
                  <i className="ri-filter-3-line text-base" />
                  按所选主题浏览
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}